<template>
  <!-- new category nav -->
  <li class="main-tab-li">
    <a
      class="wp_categoryNavAnchor"
      href=""
      @click.prevent="getCategory(tabData, 1)"
      @mouseover="categoryMainImage = tabData.background_image"
						data-test="mainTabTemplateCategoryNameLink"
    >
      {{tabData.category_name}}
    </a>
    <ul class="sub-menu">
      <div class="wp_navCategoryPadding">
        <div class="row m-0">
          <!-- 1 --->
          <div class="col-8">
            <div class="row">
              <div
                class="col-3"
                v-for="(sub_category, index1) in tabData.sub_categories"
                :key="sub_category.category_id"
              >
                <a
                  href=""
                  @click.prevent="getCategory(sub_category, 2)"
																		:data-test="'mainTabTemplateSubCategoryNameLink'+index1"
                >
                  <!--@mouseover="categoryMainImage = sub_category.background_image?-->
                  <!--sub_category.background_image : tabData.background_image"-->
                  <!--@mouseleave="categoryMainImage = tabData.background_image"-->
                  <!--&gt;-->
                  <h5 :data-test="'mainTabTemplateSubCategoryName'+index1"> {{sub_category.category_name}} </h5>
                </a>
                <li
                  v-for="(end_category, index2) in sub_category.sub_categories"
                  :key="end_category.category_id"
                >
                  <a
                    href=""
                    @click.prevent="getCategory(end_category, 3)"
																				:data-test="'mainTabTemplateEndCategoryNameLink'+index2"
                  >
                    <!--@mouseover="categoryMainImage = end_category.background_image ?-->
                    <!--end_category.background_image :(sub_category.background_image ?-->
                    <!--sub_category.background_image : tabData.background_image)"-->
                    <!--@mouseleave="categoryMainImage = tabData.background_image"-->
                    <!--&gt;-->
                    {{end_category.category_name}}
                  </a>
                </li>
              </div>

            </div>

          </div>
          <!-- 1 -->
          <!-- image or video -->
          <div class="col-4 wp_categoryNavImage">
            <img
              :src="categoryMainImage"
              alt="Category Image"
														data-test="mainTabTemplateCategoryImg"
            />
          </div>
          <!-- image or video -->
        </div>

      </div>
      <!-- <li><a href="">Sub Two</a></li> -->
    </ul>
  </li>
  <!-- <li>
      <a href="">Thing Two</a>
      <ul class="sub-menu">
        <li><a href="">Sub One</a></li>
        <li><a href="">Sub Two</a></li>
        <li><a href="">Sub Three</a></li>
      </ul>
    </li>
    <li>
      <a href="">Thing Three</a>
      <ul class="sub-menu">
        <li><a href="">Sub One</a></li>
        <li><a href="">Sub Two</a></li>
        <li><a href="">Sub Three</a></li>
        <li><a href="">Sub Four</a></li>
      </ul>
    </li>
    <li>
      <a href="">Thing Four</a>
      <ul class="sub-menu">
        <li><a href="">Sub One</a></li>
        <li><a href="">Sub Two</a></li>
        <li><a href="">Sub Three</a></li>
        <li><a href="">Sub Four</a></li>
        <li><a href="">Sub Five</a></li>
      </ul>
    </li> -->

  <!-- new category nav -->

  <!-- <li class="nav-item dropdown">
      <a class="nav-link dropdown-toggle text-capitalize main-nav"
        href=""
        :id=tabData.category_name
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        @click.prevent="getCategory(tabData, 1)"
      >
        <span style="text-transform: uppercase"
              :id="'navbar-category-'+tabData.category_name"
        >
          {{tabData.category_name}}
        </span>
      </a>
      <div class="dropdown-menu mega-drp-down-sm-prdts"
          id="mega-drp-down"
          :aria-labelledby=tabData.category_name
      >
        <div class="container-fluid">
          <div class="row  mega-drop-list-style">
            <div class="mega-drop-col"
                v-for="sub_category in tabData.sub_categories"
                :key="sub_category.category_id"
            >
              <ul class="nav flex-column">
                <li class="nav-item"  >
                  <a class="nav-link active head-title"
                    data-toggle="collapse"
                    data-target=".navbar-collapse.show"
                    href=""
                    @click.prevent="getCategory(sub_category, 2)"
                    @mouseover="categoryMainImage = sub_category.background_image?
                    sub_category.background_image : tabData.background_image"
                    @mouseleave="categoryMainImage = tabData.background_image"
                    :id="'navbar-subcategory-'+sub_category.category_name"
                  >
                    {{sub_category.category_name}}
                  </a>
                </li>
                <li class="nav-item "
                    v-for="end_category in sub_category.sub_categories"
                    :key="end_category.category_id"
                >
                  <a class="nav-link sub-title"
                    data-toggle="collapse"
                    data-target=".navbar-collapse.show"
                    href=""
                    @mouseover="categoryMainImage = end_category.background_image ?
                    end_category.background_image :(sub_category.background_image ?
                    sub_category.background_image : tabData.background_image)"
                    @mouseleave="categoryMainImage = tabData.background_image"
                    @click.prevent="getCategory(end_category, 3)"
                    :id="'navbar-endcategory-'+end_category.category_name"
                  >
                    {{end_category.category_name}}
                  </a>
                </li>
              </ul>
            </div>
            <div class="col d-none d-md-block text-right">
              <a href="" @click.prevent="getCategory(tabData, 1)">
                <img
                  :src=categoryMainImage
                  alt=""
                  class="img-fluid mega-drop-dwn-staic-img"
                  :id="'navbar-categorymain-img-'+tabData.category_name"
                >
              </a>
            </div>
          </div>
        </div>
      </div>
    </li> -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
	props: {
		tabData: null,
		index: {
			default: 0,
			type: Number
		}
	},
	mounted () {
		$(() => {
			$('.nav-link').click(() => {
				if ($('.mega-drp-down-sm-prdts').css('display') === 'none') {
					$('.nav-link').hover(() => {
						$('.mega-drp-down-sm-prdts').css('display', 'block')
					})
				} else {
					$('.mega-drp-down-sm-prdts').css('display', 'none')
				}
			})
		})
		if (this.tabData && this.tabData.background_image) {
			this.categoryMainImage = this.tabData.background_image
		}
	},
	data () {
		return {
			categoryMainImage: ''
		}
	},
	computed: {
		...mapGetters('category', ['getActiveCategory', 'getCategoryData']),
		...mapGetters('productselected', ['getSelectedProduct']),
		...mapGetters('filters', ['getKeyWord'])
	},
	methods: {
		...mapActions('productselected', ['setSelectedProductData']),
		getCategory (classifications, depth) {
			// const keyWord = {
			//   category_id: classifications.category_id,
			//   is_a_category: true };
			// productApi.getSearchProducts(keyWord)
			//   .then((res) => {
			//     if (res) {
			this.$nextTick(() => {
				this.$router.push({
					name: 'ProductList',
					path: '/product-list',
					query: {
						category: classifications.category_id,
						depth,
						name: classifications.category_name,
						display_text: classifications.category_name,
						is_a_category: true
					}
				})
			})
		}
	}
}
</script>
